import { t } from '../../utils/i18n';
import React, { useEffect, useState } from 'react';
import {
  getCommunityDataSource,
  setCommunityDataSource,
  DATA_SOURCE_MOCK,
  DATA_SOURCE_API,
} from '../../utils/communityDataSource';

export default function CommunityDataSourceToggle() {
  const [source, setSource] = useState(getCommunityDataSource);

  useEffect(() => {
    const handler = (e) => setSource(e.detail || getCommunityDataSource());
    window.addEventListener('community-data-source-change', handler);
    return () => window.removeEventListener('community-data-source-change', handler);
  }, []);

  const set = (s) => {
    setCommunityDataSource(s);
    setSource(s);
  };

  return (
    <div
      className="flex items-center rounded-full border border-dark-border p-1 bg-dark-surface"
      role="group"
      aria-label="Community data source"
    >
      <button
        type="button"
        aria-pressed={source === DATA_SOURCE_MOCK}
        onClick={() => set(DATA_SOURCE_MOCK)}
        className={`px-3 py-1 text-xs font-semibold rounded-full transition-colors ${
          source === DATA_SOURCE_MOCK
            ? 'bg-primary text-black'
            : 'text-dark-text-secondary hover:text-primary'
        }`}
      >
        {t('adminUi.mockData')}
      </button>
      <button
        type="button"
        aria-pressed={source === DATA_SOURCE_API}
        onClick={() => set(DATA_SOURCE_API)}
        className={`px-3 py-1 text-xs font-semibold rounded-full transition-colors ${
          source === DATA_SOURCE_API
            ? 'bg-primary text-black'
            : 'text-dark-text-secondary hover:text-primary'
        }`}
      >
        API
      </button>
    </div>
  );
}
